module.exports = __webpack_public_path__ + "img/sy.366d1ac8.svg";